<alaris-dialog
	[loading$]="exporting$"
	[closeAction]="close.bind(this)"
	[confirmButtonText]="''"
	size="auto"
	[closeButtonText]="''">
	<alaris-copy data="SI-{{ task.id }}" slot="header" class="copy"></alaris-copy>
	<h4 slot="header">{{ 'simulation.task.title' | translate }}&nbsp;SI-{{ task.id }}</h4>
	<div slot="content">
		<div class="task-statistics">
			<div>
				@if ( task.dippingRule ) {
					<span>{{ task.dippingRule }}</span>
				} @else {
					<span>{{ 'gl.errors.undefined' | translate }}</span>
				}
				<div>{{ 'simulation.dipping_rule' | translate }}</div>
			</div>
		</div>
		<hr class="divider" />
		<div class="task-info">
			<div>
				<div>
					<alaris-icon name="icon-spinner"></alaris-icon>
					<div>{{ 'simulation.status' | translate }}</div>
				</div>
				<div>
					<app-simulation-status [task]="task"></app-simulation-status>
				</div>
			</div>
			<div>
				<div>
					<alaris-icon name="icon-data"></alaris-icon>
					<div>{{ 'gl.created' | translate }}</div>
				</div>
				<div>
					{{ task.createdAt | dateFormat }}
				</div>
			</div>
			<div>
				<div>
					<alaris-icon name="icon-user-circle"></alaris-icon>
					<div>{{ 'gl.author' | translate }}</div>
				</div>
				<div>
					@if (task.author?.details?.firstName && task.author?.details?.lastName) {
					{{ task.author?.details?.firstName }}&nbsp;{{ task.author?.details?.lastName }}
					} @else {
					{{ task.author?.login }}
					}
				</div>
			</div>
			<div>
				<div>
					<alaris-icon name="icon-sender-ID"></alaris-icon>
					<div>{{ 'simulation.sender_id' | translate }}</div>
				</div>
				<div>
					{{ task.senderId }}
				</div>
			</div>
			<div>
				<div>
					<alaris-icon name="icon-rate"></alaris-icon>
					<div>{{ 'simulation.prefix' | translate }}</div>
				</div>
				<div>
					{{ task.prefix }}
				</div>
			</div>
			<div>
				<div>
					<alaris-icon name="icon-package"></alaris-icon>
					<div>{{ 'simulation.product_name' | translate }}</div>
				</div>
				<div>
					{{ task.productName }}
				</div>
			</div>
			<div>
				<div>
					<alaris-icon name="icon-partner"></alaris-icon>
					<div>{{ 'simulation.client_product' | translate }}</div>
				</div>
				<div>
					{{ task.productLabel }}
				</div>
			</div>
		</div>
	</div>
	<div slot="footer-extra" class="footer-actions">
		<button alarisButton [bType]="'secondary'" size="lg" [ripple]="true" (click)="restart()">
			{{ 'simulation.task.restart' | translate }}
		</button>
	</div>
</alaris-dialog>
